import React from 'react';
import { useState } from 'react';
import { sendMessageAPI } from '../../Utils/APIs/sendMessageApi';

const SendMessage = () => {
    const departmentList = [
        'All',
        'HOD Team',
        'Warehouse',
        'Field Service'
    ];
    
    const [formData, setFormData] = useState({});
    const [individualMessage, setIndividualMessage] = useState({
        contact: '',
        language: '',
        message: ''
    });
    const [isBulkLoading, setIsBulkLoading] = useState(false);
    const [isIndividualLoading, setIsIndividualLoading] = useState(false);

    const handleBulkChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    }

    const handleIndividualChange = (e) => {
        const { name, value } = e.target;
        setIndividualMessage((prev) => ({ ...prev, [name]: value }));
    }

    const handleBulkSubmit = async (e) => {
        e.preventDefault();
        setIsBulkLoading(true);
        sendMessageAPI(`admin/bulkWhatsAppMessage`, formData)
            .then((res) => {
                if (res) {
                    alert('Bulk Message Sent Successfully');
                }
            })
            .finally(() => {
                setIsBulkLoading(false);
            });
    }

    const handleIndividualSubmit = async (e) => {
        e.preventDefault();
        setIsIndividualLoading(true);
        sendMessageAPI(`admin/unknownWhatsApp`, individualMessage)
            .then((res) => {
                if (res) {
                    alert('Individual Message Sent Successfully');
                }
            })
            .finally(() => {
                setIsIndividualLoading(false);
            });
    }

    return (
        <div className="w-auto flex flex-col">
            <div className="mainHeading">
                <h1 className='text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50 rounded-lg'>M<span className='text-lg'>ESSAGING</span> S<span className='text-lg'>YSTEM</span></h1>
            </div>
            
            <div className="flex flex-col md:flex-row gap-6 m-6">
            
                <div className="flex-1 p-6 border border-gray-200 rounded-lg shadow">
                    <h2 className="text-xl font-semibold mb-4 text-center">Individual Message</h2>
                    <form onSubmit={handleIndividualSubmit}>
                        <div className="flex flex-col gap-4">
                            <div>
                                <label htmlFor="contact" className="block mb-2 text-sm font-medium text-gray-900">
                                    Phone Number<span className='text-red-500'>*</span>
                                </label>
                                <input
                                    type="number"
                                    id="contact"
                                    name="contact"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                    placeholder="Enter phone number with country code"
                                    value={individualMessage.contact}
                                    onChange={handleIndividualChange}
                                    required
                                />
                            </div>
                            
                            <div>
                                <label className="block mb-2 text-sm font-medium text-gray-900">
                                    Choose Language<span className='text-red-500'>*</span>
                                </label>
                                <div className="flex gap-4">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="language"
                                            value="Hindi"
                                            checked={individualMessage.language === 'Hindi'}
                                            onChange={handleIndividualChange}
                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                                            required
                                        />
                                        Hindi
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="language"
                                            value="English"
                                            checked={individualMessage.language === 'English'}
                                            onChange={handleIndividualChange}
                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                                        />
                                        English
                                    </label>
                                </div>
                            </div>
                            
                            <div>
                                <label htmlFor="individualMessage" className="block mb-2 text-sm font-medium text-gray-900">
                                    Message<span className='text-red-500'>*</span>
                                </label>
                                <textarea
                                    id="individualMessage"
                                    name="message"
                                    rows="6"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                                    placeholder="Type your message here"
                                    value={individualMessage.message}
                                    onChange={handleIndividualChange}
                                    required
                                ></textarea>
                            </div>
                            
                            <div className="flex justify-end">
                                <button
                                    type="submit"
                                    className="text-white bg-black hover:bg-gray-800 font-medium rounded-sm text-sm px-5 py-2.5 text-center flex items-center justify-center min-w-[150px]"
                                    disabled={isIndividualLoading}
                                >
                                    {isIndividualLoading ? (
                                        <>
                                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Sending...
                                        </>
                                    ) : 'Send to Individual'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

                {/* Right Side - Bulk Message */}
                <div className="flex-1 p-6 border border-gray-200 rounded-lg shadow">
                    <h2 className="text-xl font-semibold mb-4 text-center">Bulk Message</h2>
                    <form onSubmit={handleBulkSubmit}>
                        <div className="flex flex-col gap-4">
                            <div>
                                <label htmlFor="department-select" className="block mb-2 text-sm font-medium text-gray-900">
                                    Select Department<span className='text-red-500'>*</span>
                                </label>
                                <select
                                    id="department-select"
                                    name="sendTo"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                    value={formData.sendTo || ''}
                                    onChange={handleBulkChange}
                                    required
                                >
                                    <option value="">-- Select Department --</option>
                                    {departmentList.map((department, index) => (
                                        <option key={index} value={department}>
                                            {department}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            
                            <div>
                                <label className="block mb-2 text-sm font-medium text-gray-900">
                                    Choose Language<span className='text-red-500'>*</span>
                                </label>
                                <div className="flex gap-4">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="language"
                                            value="Hindi"
                                            checked={formData.language === 'Hindi'}
                                            onChange={() => setFormData(prev => ({ ...prev, language: 'Hindi' }))}
                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                                            required
                                        />
                                        Hindi
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="language"
                                            value="English"
                                            checked={formData.language === 'English'}
                                            onChange={() => setFormData(prev => ({ ...prev, language: 'English' }))}
                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                                        />
                                        English
                                    </label>
                                </div>
                            </div>
                            
                            <div>
                                <label htmlFor="bulkMessage" className="block mb-2 text-sm font-medium text-gray-900">
                                    Message<span className='text-red-500'>*</span>
                                </label>
                                <textarea
                                    id="bulkMessage"
                                    name="message"
                                    rows="6"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                                    placeholder="Type your message here"
                                    value={formData.message || ''}
                                    onChange={handleBulkChange}
                                    required
                                ></textarea>
                            </div>
                            
                            <div className="mt-2">
                                <p className="text-sm text-red-500">Note: Don't break paragraphs in your message.</p>
                            </div>
                            
                            <div className="flex justify-end">
                                <button
                                    type="submit"
                                    className="text-white bg-black hover:bg-gray-800 font-medium rounded-sm text-sm px-5 py-2.5 text-center flex items-center justify-center min-w-[150px]"
                                    disabled={isBulkLoading}
                                >
                                    {isBulkLoading ? (
                                        <>
                                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Sending...
                                        </>
                                    ) : 'Send to Department'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default SendMessage;